// extracted by mini-css-extract-plugin
export var backButton = "_1g-1";
export var content = "_1g-d";
export var continueButton = "_1g-7";
export var continueHint = "_1g-8";
export var continueRow = "_1g-6";
export var leftInner = "_1g-0";
export var shell = "_1g-e";
export var sidebarContent = "_1g-5";
export var skipButton = "_1g-c";
export var spacer = "_1g-2";
export var spin = "_1g-a";
export var spinner = "_1g-9";
export var spinnerOverlay = "_1g-b";
export var subtitle = "_1g-4";
export var title = "_1g-3";